<template>
<v-container grid-list-md>
    <v-row>

        <v-col cols="12">
            <im-sales-velocity-widget :url="endpoint" />
        </v-col>

        <v-col cols="12">
            <im-hotel-availability-widget :url="endpoint" />
        </v-col>

        <v-col cols="12">
            <v-card>

                <v-sheet>
                    <v-container fluid class="pa-0 ma-0">
                        <v-card-text>
                            <div class="subheading text-uppercase">Chart Intervals</div>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-menu v-model="menu_date_from" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="date_from" v-on="on" label="From" filled append-icon="event" readonly hide-details />
                                        </template>
                                        <v-date-picker v-model="date_from" @change="getCharts()" :max="date_until" />
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-menu v-model="menu_date_until" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="date_until" v-on="on" label="Until" filled append-icon="event" readonly hide-details />
                                        </template>
                                        <v-date-picker v-model="date_until" @change="getCharts()" :min="date_from" />
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-container>
                </v-sheet>

                <v-divider />

                <v-col cols="12">
                    <im-sales-volume-chart class="elevation-0" :url="endpoint" :from="date_from" :until="date_until" />
                </v-col>

                <v-divider />

                <v-col cols="12">
                    <im-client-agency-chart class="elevation-0" :url="endpoint" :from="date_from" :until="date_until" />
                </v-col>

                <v-divider />

                <v-col cols="12">
                    <im-agency-type-chart class="elevation-0" :url="endpoint" :from="date_from" :until="date_until" />
                </v-col>

                <v-divider />

                <v-col cols="12">
                    <im-status-chart class="elevation-0" :url="endpoint" :from="date_from" :until="date_until" />
                </v-col>

                <v-divider />

                <v-col cols="12">
                    <im-hotel-sales-widget class="elevation-0" :url="endpoint" :from="date_from" :until="date_until" />
                </v-col>
            </v-card>
        </v-col>

    </v-row>
</v-container>
</template>
<script>
import moment from 'moment';

import SalesVelocityWidget from "../components/charts/dashboard/SalesVelocityWidget.vue";
import SalesVolumeChart from "../components/charts/dashboard/SalesVolumeChart.vue";
import ClientAgencyChart from "../components/charts/dashboard/ClientAgencyChart.vue";
import AgencyTypeChart from "../components/charts/dashboard/AgencyTypeChart.vue";
import StatusChart from "../components/charts/dashboard/StatusChart.vue";
import HotelSalesWidget from "../components/charts/dashboard/HotelSalesWidget.vue";
import HotelAvailabilityWidget from "../components/charts/dashboard/HotelAvailabilityWidget";

export default {

    components: {
        'im-sales-velocity-widget': SalesVelocityWidget,
        'im-hotel-sales-widget': HotelSalesWidget,
        'im-hotel-availability-widget': HotelAvailabilityWidget,
        'im-sales-volume-chart': SalesVolumeChart,
        'im-client-agency-chart': ClientAgencyChart,
        'im-agency-type-chart': AgencyTypeChart,
        'im-status-chart': StatusChart
    },

    methods: {
        getCharts() {
            this.menu_date_from = false;
            this.menu_date_until = false;
        }
    },

    data() {

        return {
            endpoint: process.env.VUE_APP_HTTP_SECURE === "true" ? ("https://" + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/bookings/charts') : ("http://" + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY +
                '/api/services-new/bookings/charts'),
            menu_date_from: false,
            menu_date_until: false,
            date_from: moment()
                .subtract(1, 'months')
                .format("YYYY-MM-DD"),
            date_until: moment()
                .format("YYYY-MM-DD")
        }
    }
}
</script>
